import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/dentlab/src/lib/utils/cn";
import {
	Receipt,
	List,
	AlertTriangle,
	Ban,
	FileText,
	Banknote,
	RotateCcw,
	BellRing,
} from "lucide-react";
import { useRemindersStore } from "../../../store/Reminders";

export const DebitorenMenu = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;
	const dueReminderCount = useRemindersStore((state) => state.dueCount);

	useEffect(() => {
		useRemindersStore.getState().fetchDueCount();
	}, []);

	const isPathActive = (path: string) => {
		return currentPath === path;
	};

	const menuItems = [
		{
			title: "Fakturajournal",
			icon: <Receipt size={16} />,
			path: "/debitoren/fakturajournal",
		},
		{
			title: "Offene Posten",
			icon: <FileText size={16} />,
			path: "/debitoren/offene-posten",
		},
		{
			title: "Zahlungsjournal",
			icon: <Banknote size={16} />,
			path: "/debitoren/zahlungsjournal",
		},
		{
			title: "Stornojournal",
			icon: <Ban size={16} />,
			path: "/debitoren/stornojournal",
		},
		{
			title: "Akontoansicht",
			icon: <List size={16} />,
			path: "/debitoren/akontoansicht",
		},
		{
			title: "Verlustansicht",
			icon: <AlertTriangle size={16} />,
			path: "/debitoren/verlustansicht",
		},
		{
			title: "Rückvergütungen",
			icon: <RotateCcw size={16} />,
			path: "/debitoren/rueckverguetungen",
		},
		{
			title: "Mahnwesen",
			icon: <BellRing size={16} />,
			path: "/debitoren/mahnwesen",
			badge: dueReminderCount,
		},
	];

	return (
		<div className="flex items-center gap-1">
			{menuItems.map((item, index) => (
				<button
					key={index}
					onClick={() => navigate(item.path)}
					className={cn(
						"flex items-center gap-1 px-2 py-1 text-sm rounded-md transition-colors",
						isPathActive(item.path)
							? "bg-stone-200 text-gray-800 font-medium"
							: "text-gray-700 hover:bg-stone-200"
					)}
					aria-label={item.title}
					data-testid={`debitoren-menu-${item.path.split("/").pop()}`}
				>
					<span
						className={
							isPathActive(item.path)
								? "text-gray-800"
								: "text-gray-600"
						}
					>
						{item.icon}
					</span>
					<span>{item.title}</span>
					{!!item.badge && (
						<span
							className="ml-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold text-white"
							aria-label={`${item.badge} fällige Mahnungen`}
							data-testid="mahnwesen-due-badge"
						>
							{item.badge}
						</span>
					)}
				</button>
			))}
		</div>
	);
};
